// extracted by mini-css-extract-plugin
export default {"clockLoader":"ZKuIn","hand":"xs8Cf","minute":"HTqNC","tic":"iYvmC","hour":"RAjwS"};